export default __webpack_public_path__ + "static/media/skyward_harp.6961093e.png";